import React from 'react';
import { Button } from './ui/button';
import { Github, Linkedin, Mail, ArrowDown } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Hero = () => {
  const scrollToProjects = () => {
    document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 text-center">
        <div className="animate-fade-in-up">
          {/* Name */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 tracking-tight">
            {personalInfo.name}
          </h1>
          
          {/* Title */}
          <h2 className="text-2xl md:text-3xl font-semibold text-teal-400 mb-6">
            {personalInfo.title}
          </h2>
          
          {/* Tagline */}
          <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto mb-8 leading-relaxed">
            {personalInfo.tagline}
          </p>

          {/* Social Links */}
          <div className="flex items-center justify-center gap-4 mb-10">
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-slate-800/50 hover:bg-slate-700/50 rounded-lg transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-teal-500/20"
            >
              <Github className="w-6 h-6 text-slate-300" />
            </a>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-slate-800/50 hover:bg-slate-700/50 rounded-lg transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-teal-500/20"
            >
              <Linkedin className="w-6 h-6 text-slate-300" />
            </a>
            <a
              href={`mailto:${personalInfo.email}`}
              className="p-3 bg-slate-800/50 hover:bg-slate-700/50 rounded-lg transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-teal-500/20"
            >
              <Mail className="w-6 h-6 text-slate-300" />
            </a>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              onClick={scrollToProjects}
              className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-6 text-lg font-medium rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-teal-500/30"
            >
              View Projects
            </Button>
            <Button
              onClick={scrollToContact}
              variant="outline"
              className="border-2 border-teal-500 text-teal-400 hover:bg-teal-500/10 px-8 py-6 text-lg font-medium rounded-lg transition-all duration-300 hover:scale-105"
            >
              Hire Me
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ArrowDown className="w-6 h-6 text-teal-400" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
